export default __webpack_public_path__ + "static/media/atlassian-svgrepo-com.22389694.svg";